import { Box, Checkbox, FormControlLabel, Stack } from '@mui/material';
import React from 'react';

interface QuoteEditorRateOptionsProps {
  includePerDiem: boolean;
  includeMiscFees: boolean;
  showArea: boolean;
  showToolsGear: boolean;
  disabled?: boolean;
  onIncludePerDiemChange: (checked: boolean) => void;
  onIncludeMiscFeesChange: (checked: boolean) => void;
  onShowAreaChange: (checked: boolean) => void;
  onShowToolsGearChange: (checked: boolean) => void;
}

const optionSx = {
  ml: 0,
  color: '#000',
  '.MuiFormControlLabel-label': {
    fontSize: 13,
    fontWeight: 700,
    whiteSpace: 'nowrap'
  }
};

const divider = (
  <Box
    aria-hidden="true"
    sx={{
      width: '1px',
      height: 22,
      bgcolor: 'rgba(0,0,0,0.14)',
      flexShrink: 0,
      mx: 0.5
    }}
  />
);

/** Shared quote worksheet option strip in a fixed cross-lifecycle order. */
export default function QuoteEditorRateOptions({
  includePerDiem,
  includeMiscFees,
  showArea,
  showToolsGear,
  disabled = false,
  onIncludePerDiemChange,
  onIncludeMiscFeesChange,
  onShowAreaChange,
  onShowToolsGearChange
}: QuoteEditorRateOptionsProps) {
  const options = [
    { label: 'Area/Zone', checked: showArea, onChange: onShowAreaChange },
    {
      label: 'Tools/Gear',
      checked: showToolsGear,
      onChange: onShowToolsGearChange
    },
    {
      label: 'Per Diem',
      checked: includePerDiem,
      onChange: onIncludePerDiemChange
    },
    {
      label: 'Misc Fees',
      checked: includeMiscFees,
      onChange: onIncludeMiscFeesChange
    }
  ];

  return (
    <Stack
      data-testid="shared-quote-rate-options"
      direction="row"
      alignItems="center"
      spacing={1}
      useFlexGap
      flexWrap="wrap"
    >
      <Box component="span" sx={{ fontSize: 13, color: '#000', whiteSpace: 'nowrap' }}>
        Select additional columns:
      </Box>
      {options.map((option, index) => (
        <React.Fragment key={option.label}>
          {index === 2 && divider}
          <FormControlLabel
            control={(
              <Checkbox
                size="small"
                checked={option.checked}
                onChange={(event) => option.onChange(event.target.checked)}
                disabled={disabled}
                inputProps={{ 'aria-label': option.label }}
                sx={{
                  color: '#E8BF21',
                  '&.Mui-checked': { color: '#E8BF21' }
                }}
              />
            )}
            label={option.label}
            sx={optionSx}
          />
        </React.Fragment>
      ))}
    </Stack>
  );
}
